import { useNavigate } from 'react-router-dom';
import { Button, Tooltip } from '@material-ui/core';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { useSidebarOpenState } from '@backstage/core-components';

export const SettingsButton = () => {
  const navigate = useNavigate();
  const { isOpen } = useSidebarOpenState();

  return isOpen ? (
    <Tooltip
      title="Show user identity & settings"
      placement="bottom"
      PopperProps={{
        modifiers: {
          offset: { offset: '0, -6' },
        },
      }}
    >
      <Button
        size="small"
        color="primary"
        onClick={() => navigate('/settings')}
        style={{ minWidth: 'unset' }}
      >
        <UserSettingsSignInAvatar />
      </Button>
    </Tooltip>
  ) : null;
};
